import { render, staticRenderFns } from "./file-item.vue?vue&type=template&id=4c1b8b38&"
import script from "./file-item.vue?vue&type=script&lang=ts&"
export * from "./file-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1b8b38')) {
      api.createRecord('4c1b8b38', component.options)
    } else {
      api.reload('4c1b8b38', component.options)
    }
    module.hot.accept("./file-item.vue?vue&type=template&id=4c1b8b38&", function () {
      api.rerender('4c1b8b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/file/file-item.vue"
export default component.exports